var render = function render(){var _vm=this,_c=_vm._self._c;return _c('boxStyle',{staticClass:"fullscreen-monitoring"},[_c('contentTitle',{attrs:{"isFull":_vm.isFull,"title":_vm.title}}),_vm._v(" "),_c('MonitoringItem',{attrs:{"loading":_vm.loading,"lableKey":_vm.lableKey,"valueKey":_vm.valueKey,"list":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }